import React, { Component } from 'react';
import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { SearchBox } from '@fluentui/react/lib/SearchBox';
import {
  List,
  Checkbox,
  ITextField,
  IChoiceGroupOption,
  ChoiceGroup,
  Callout,
  DirectionalHint,
  Spinner,
  SpinnerSize,
} from '@fluentui/react';
import './PickerComponent.css';
import { FontIcon } from '@fluentui/react';
import { findIndex, orderBy, uniqBy } from 'lodash-es';
import { removeItemInArray, UATConstants } from 'src/Common/Models/UATConstants';
import _ from 'lodash-es';

export interface SearchState {
  selectedItems: string[];
  dropdownOptions: IDropdownOption[];
  items: IPickerListOption[];
  filterText: string;
  showContent: boolean;
}

export interface IPickerListOption extends IDropdownOption {
  isChecked: boolean;
}

export interface SearchProps {
  selectedItems: string[];
  dropdownOptions: IDropdownOption[];
  placeholder: string;
  label: string;
  disabled?: boolean;
  searchable?: boolean;
  individualItem?: boolean;
  canSelectAll?: boolean;
  preSearch?: boolean;
  id?: string;
  onChangeCallBack: (item: any) => void;
  onBlurCallback?: (item: any) => void;
  showLogicalRadioButton?: boolean;
  onLogicalRadioButtonChangeCallBack?: Function;
  disableSort?: boolean;
  styleSearchClass?: boolean;
  manageActionStyle?: boolean;
  clickLabel?: string;
  onSearchChange?: (searchText: string) => void;
  separator?: string;
  resolvingOptions?: boolean;
}

const SelectAllKey: string = 'SelectAllItems';
const SelectAllText: string = 'Select All';

//This component is to implement multiselect dropdown. based on the props it can be customized.
export class SearchComponent extends Component<SearchProps, SearchState> {
  private node: any;
  private filterInput: ITextField | null;

  constructor(props: any) {
    super(props);
    this.state = {
      selectedItems: this.props?.selectedItems,
      dropdownOptions: this.props?.dropdownOptions,
      filterText: '',
      items: [],
      showContent: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.setAllSelectedItems = this.setAllSelectedItems.bind(this);
    this.handleInsideClick = this.handleInsideClick.bind(this);
    this.setRadioOption = this.setRadioOption.bind(this);
  }

  componentDidMount() {
    this.filterInput?.focus();
    this.loadData();
  }

  //this method handles the opening and closing of the dropdown based on the click
  handleClick(showContent: boolean) {
    this.setState({ showContent: showContent });
  }

  handleInsideClick(e: any) {
    if (e.key == UATConstants.PlaceholdersAndTitles.Enter) {
      this.setState({ showContent: false });
      this.handleClick(true);
    }
  }

  //this methid handles the outside clicks and scrolls and closes the dropdown based on certain conditions
  handleOutsideClick(e: Event) {
    // ignore clicks on the component itself
    if (this.node != null && this.node.contains(e.target)) {
      return;
    }
    //make false even if clicked in dropdown header
    if (this.preventClosingList) {
      this.handleClick(this.preventClosingList);
    } else {
      this.handleClick(false);
    }

    this.props.onBlurCallback?.(this.state.selectedItems);
    this.preventClosingList = false;
  }

  preventClosingList = false;

  //this method handles the dropdown in case of data change and sets the values of the component as per the previous state and new props
  UNSAFE_componentWillReceiveProps(nextProps: SearchProps) {
    let { items = [] } = this.state;

    // If items are not yet initialised but new options have arrived, bootstrap from nextProps.dropdownOptions
    const realItems = items.filter((x) => x.key !== SelectAllKey);
    if (realItems.length === 0 && nextProps.dropdownOptions?.length > 0) {
      items = [];
      nextProps.dropdownOptions.forEach((item: any) => {
        if (item && item.key !== undefined && item.text !== undefined) {
          items.push({
            key: item.key as string,
            text: item.text as string,
            title: item.title ? item.title as string : item.text as string,
            isChecked: false,
            disabled: item.disabled ?? false,
          });
        }
      });
      items = uniqBy(items, (e) => e.key);
      if (!nextProps.disableSort) {
        items = items.sort((a, b) => a.text.localeCompare(b.text));
      }
    }

    items = items.filter((x) => x.key !== SelectAllKey);
    items.forEach((x) => (x.isChecked = false));
    nextProps.selectedItems.forEach(function (value) {
      const target = items.find((x) => x.text === value);
      if (target) target.isChecked = true;
    });
    if (!this.props.disableSort) {
      items = items.sort((a, b) => a.text.localeCompare(b.text));
    }
    if (this.state.filterText === '' && this.props.canSelectAll && nextProps.dropdownOptions?.length > 0) {
      items.unshift({
        key: SelectAllKey,
        text: SelectAllText,
        isChecked:
          nextProps.selectedItems.length + items.filter((x) => x.disabled).length ===
          nextProps.dropdownOptions.length && nextProps.dropdownOptions.length > 0,
      });
    }

    this.setState({
      items: items,
      selectedItems: nextProps.selectedItems,
    });
  }
  componentDidUpdate(prevProps: SearchProps) {
    // Only update if dropdownOptions or selectedItems have changed
    if (this.props.onSearchChange) {
      if (
        prevProps.dropdownOptions !== this.props.dropdownOptions ||
        prevProps.selectedItems !== this.props.selectedItems
      ) {
        let items: IPickerListOption[] = [];
        const BlockerColumns = this.props.dropdownOptions;
        if (BlockerColumns && BlockerColumns.length > 0) {
          BlockerColumns.forEach((item: any) => {
            items.push({
              key: item.key as string,
              text: item.text as string,
              title: item.title ? item.title as string : '',
              isChecked: this.props.selectedItems.includes(item.text),
              disabled: item.disabled,
            });
          });
        }

        items = uniqBy(items, (e) => e.key);
        if (!this.props.disableSort) {
          items = items.sort((a, b) => a.text.localeCompare(b.text));
        }
        if (
          this.state.filterText === '' &&
          this.props.canSelectAll &&
          this.props.dropdownOptions?.length > 0
        ) {
          items.unshift({
            key: SelectAllKey,
            text: SelectAllText,
            isChecked:
              this.props.selectedItems.length + items.filter((x) => x.disabled).length ===
              this.props.dropdownOptions.length && this.props.dropdownOptions.length > 0,
            disabled: false,
          });
        }

        this.setState({
          items: items,
          selectedItems: this.props.selectedItems,
        });
      }
    } else if (prevProps.dropdownOptions !== this.props.dropdownOptions) {
      const existingItems = this.state.items.filter(i => i.key !== SelectAllKey);
      if (existingItems.length === 0 && this.props.dropdownOptions.length > 0) {
        // Items not yet initialized (mounted before options loaded) - full rebuild
        this.loadData();
      } else {
        // Options already populated - just sync disabled/title flags without resetting order or selection
        this.setState(prevState => ({
          items: prevState.items.map(item => {
            const opt = this.props.dropdownOptions.find(o => String(o.key) === String(item.key));
            return opt
              ? {
                  ...item,
                  disabled: opt.disabled ?? item.disabled,
                  title: opt.title !== undefined ? opt.title : opt.text,
                }
              : item;
          }),
        }));
      }
    }
  }
  // takes the id of the cross button which is the value of the selected option and removes it from the selected list
  deleteItem = (event: any) => {
    let selectedKeys = [...this.state.selectedItems];
    removeItemInArray(selectedKeys, event.target.id);
    this.setState({
      selectedItems: selectedKeys,
    });
    this.props.onChangeCallBack(selectedKeys);
    event.stopPropagation();
  };

  //Handles the title based on certain props
  onRenderTitle = (options: string[]): JSX.Element => {
    const selectedItemText = options
      .map((a, i) => {
        if (a !== SelectAllText && a !== '') {
          return (
            <span
              key={`item-title` + i}
              className={`${this.props.disabled ? 'selectedValueDisabled' : 'selectedValue'}`}
              aria-disabled={this.props.disabled}>
              {a}{' '}
              <button
                type="button"
                aria-label={`remove ${a}`}
                onClick={(event: any) => !this.props.disabled ? this.deleteItem(event) : {}}
                id={a}
                className='removeIcon'>
                <FontIcon
                  iconName='Cancel'
                  id={a}
                  className={'deleteValue'}
                />
              </button>
            </span>
          );
        } else {
          return null;
        }
      })
      .filter((item) => item !== null);

    if (this.props.searchable) {
      selectedItemText.push(
        <span key={'item-area'}>
          <span className='TitlePlaceholder'>{this.props.placeholder}</span>
        </span>
      );
    } else {
      if (!this.state.showContent) {
        selectedItemText.push(
          <span key={'item-eou'}>
            <button className='clickToAdd' disabled={this.props.disabled} title={this.props.clickLabel ? this.props.clickLabel : UATConstants.PlaceholdersAndTitles.ClickToAdd}>
              {this.props.clickLabel
                ? this.props.clickLabel
                : UATConstants.PlaceholdersAndTitles.ClickToAdd}
            </button>
          </span>
        );
      }
    }

    return (
      <div className='crossItems'>
        {selectedItemText && selectedItemText.length > 0 ? selectedItemText : this.props.label}
      </div>
    );
  };

  //Stops closing of the dropdown when searchbox is clicked
  onSearchClick(event: any) {
    if (this.state.showContent) {
      event.stopPropagation();
    }
  }
  private options: IChoiceGroupOption[] = [
    { key: 'Or', text: 'Or' },
    { key: 'And', text: 'And', styles: { field: { marginLeft: '10px' } } },
  ];

  render() {
    const { items = [] } = this.state;
    const disabled = this.props.disabled;
    let pickerClass = disabled ? 'pickerContent pickerDisabled' : 'pickerContent';

    let selectedText = this.state.selectedItems.filter(Boolean).join(this.props.separator || ', ');
    let styleSearchClass = this.props.styleSearchClass;
    let pickerTitleClass = this.props?.manageActionStyle
      ? 'picker-title picker-content-height remove-manageaction-border'
      : styleSearchClass
        ? 'picker-title picker-content-height'
        : 'picker-title';
    if (disabled) {
      pickerTitleClass = 'picker-title picker-title-disabled';
    }

    return (
      <div
        id={this.props.id}
        className={pickerClass}
        data-is-focusable={!disabled}
        ref={(node) => {
          this.node = node;
        }}
        onKeyPress={(e) => this.handleInsideClick(e)}>
        <div
          className='pickerHeader'
          onClick={() => {
            this.setState(
              {
                showContent: !disabled && !this.state.showContent,
              },
              () => {
                if (this.state.showContent) {
                  this.filterInput?.focus();
                  this.loadData();
                  this.handleClick(this.state.showContent);
                  if (this.props.onSearchChange) {
                    this.props.onSearchChange('');
                  }
                }
              }
            );
          }}>
          <span
            className={pickerTitleClass}
            title={
              this.props.individualItem
                ? undefined
                : this.state.selectedItems.filter(Boolean).join(this.props.separator || ', ')
            }>
            {this.props.individualItem
              ? this.onRenderTitle(this.state.selectedItems)
              : selectedText.length > 0
                ? selectedText
                : this.props.label}
          </span>
          {!this.props.individualItem ? (
            <span className='picker-caret'>
              <button
                // autoFocus Commented for auto scrolling issue in the dropdown
                className='chevronIconButton'
                aria-label={UATConstants.PlaceholdersAndTitles.ChevronDown}
              >
                <FontIcon
                  iconName={UATConstants.PlaceholdersAndTitles.ChevronDown}
                  className='chevronIcon'
                />
              </button>
            </span>
          ) : null}
        </div>
        {this.state.showContent && (
          <Callout
            target={this.node}
            styles={{
              root: {
                width: this.node ? this.node.getBoundingClientRect().width : 320,
                backgroundColor: 'white',
              },
            }}
            onDismiss={() => {
              this.setState({ showContent: false });
              this.props.onBlurCallback?.(this.state.selectedItems);
            }}
            directionalHint={DirectionalHint.bottomLeftEdge}
            isBeakVisible={false}
            gapSpace={0}>
            {this.props.showLogicalRadioButton && (
              <div className='logical-radio-button logical-radio-btn'>
                <ChoiceGroup
                  defaultSelectedKey='Or'
                  className='d-flex'
                  options={this.options}
                  onChange={this.setRadioOption}
                  required={false}
                />{' '}
              </div>
            )}
            {this.props.searchable && !this.props.individualItem ? (
              <div className='pickerFilterSection'>
                <SearchBox
                  className='pickerFilterBox'
                  placeholder={UATConstants.PlaceholdersAndTitles.FilterColumnName}
                  onChange={this._onFilterChanged}
                  disabled={disabled}
                />
              </div>
            ) : (
              <span key={'item-area'}>
                {this.state.showContent ? (
                  <div>
                    {' '}
                    <SearchBox
                      placeholder={UATConstants.PlaceholdersAndTitles.FilterValues}
                      defaultValue={this.state.filterText}
                      onSearch={(event: any) => this._onFilterChanged(_, event?.target.value)}
                      onChange={(event: any) => this._onFilterChanged(_, event?.target.value)}
                    />{' '}
                  </div>
                ) : (
                  <button className='clickToAdd' onClick={this.onSearchClick} title={this.props.clickLabel ? this.props.clickLabel : UATConstants.PlaceholdersAndTitles.ClickToAdd}>
                    <span className='TitlePlaceholder'>{this.props.placeholder}</span>
                  </button>
                )}
              </span>
            )}

            <div aria-busy={this.props.resolvingOptions} style={{ position: 'relative' }}>
              <div className='listContainer'>
                {items.length > 0 && (
                  <List
                    items={items}
                    onRenderCell={this._onRenderCell}
                    getItemCountForPage={() => 10}
                    renderedWindowsAhead={10}
                  />
                )}
              </div>
              {this.props.resolvingOptions && (
                <div
                  aria-label={`Loading ${this.props.label || 'dropdown'} options`}
                  style={{
                    position: 'absolute',
                    inset: 0,
                    zIndex: 12,
                    minHeight: 72,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.72)',
                    cursor: 'wait',
                    pointerEvents: 'auto',
                  }}>
                  <Spinner
                    size={SpinnerSize.large}
                    label='Updating options...'
                    styles={{
                      root: {
                        padding: 16,
                        borderRadius: 4,
                        backgroundColor: 'rgba(255, 255, 255, 0.92)',
                      },
                      circle: {
                        width: 36,
                        height: 36,
                        borderWidth: 3,
                      },
                      label: {
                        color: '#323130',
                        fontWeight: 600,
                      },
                    }}
                  />
                </div>
              )}
            </div>
          </Callout>
        )}
      </div>
    );
  }

  public _onChange(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
    console.dir(option);
    //this.setRadioOption(option)
    //this.props.onLogicalRadioButtonChangeCallBack?.(option)
  }

  //returns the index of the value in the dropdown options
  private findIndexInSeletedItemsList = (items: IPickerListOption[], key: string): boolean => {
    return items && items.findIndex((x) => x?.key?.toString() === key && x?.isChecked) > -1;
  };

  //handles the rendering of each value in the dropdown
  public _onRenderCell = (item: IPickerListOption): JSX.Element => {
    const { items = [] } = this.state;
    item.isChecked = this.findIndexInSeletedItemsList(items, item.key?.toString() || '');

    return (
      <div>
        <div className={`PickList--multiSelectableElement ${this.props.disabled || item.disabled ? 'disabled' : ''}`}>
          <div
            className={`pickList--checkbox  cursor-pointer bolt-focus-treatment ${this.props.disabled || item.disabled ? 'disabled' : 'enabled'}`}
          >
            <Checkbox
              ariaLabel={item.text}
              key={item.key}
              aria-selected={item.isChecked ? 'true' : 'false'}
              checked={item.isChecked}
              disabled={this.props.disabled || item.disabled}
              onChange={this._onItemClick(item)}
            />
          </div>
          <div className='PickList--multiSelectTextContainer' onClick={this._onItemClick(item)}>
            <div className='ms-TooltipHost host_e6f6b93f'>
              <span className='PickList--multiSelectText' title={item.title ? item.title : item.text}>
                {item.text}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  private _onItemClick = (
    item: IPickerListOption
  ): ((event: React.MouseEvent<HTMLDivElement>) => void) => {
    return (event: React.MouseEvent<HTMLDivElement>): void => {
      if (!this.props.disabled && !item.disabled) {
        this.preventClosingList = false;
        if (item.key === SelectAllKey && this.props.canSelectAll) {
          this.setAllSelectedItems(item);
        } else {
          this.setSelectedIndex(item);
        }
      }
    };
  };

  //handles the select all event.
  private setAllSelectedItems(selectAll: IPickerListOption): void {
    let { items } = this.state;
    var nextState = !selectAll.isChecked;

    items.forEach((x) => (x.isChecked = nextState));

    this.setState({ items: items }, () => {
      const pass = this.state.items
        .filter((x) => x.isChecked && x.key !== SelectAllKey)
        .map((x) => x.text);

      this.props.onChangeCallBack(pass);
    });
  }

  private setRadioOption(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
    this.props.onLogicalRadioButtonChangeCallBack?.(option.key);
  }

  //Handles the selection of an item event.
  private setSelectedIndex(item: IPickerListOption): void {
    let { items, selectedItems } = this.state;
    let newItems = [...items];
    const newSelectedItems = [...selectedItems];
    const selectAll = newItems.find((x) => x.key === SelectAllKey);
    if (selectAll && this.props.canSelectAll) {
      newItems.splice(newItems.map((x) => x.key).indexOf(selectAll.key), 1);
    }

    const arrayIndex = findIndex(newItems, item);

    if (this.findIndexInSeletedItemsList(items, item.key?.toString() || '')) {
      item.isChecked = false;
      newSelectedItems.splice(newSelectedItems.indexOf(item.text), 1);
    } else {
      item.isChecked = true;
      newSelectedItems.push(item.text);
    }

    newItems[arrayIndex] = item;
    if (!this.props.disableSort) {
      newItems = orderBy(newItems.slice(), 'isChecked', ['desc']);
    }
    if (selectAll && this.props.canSelectAll) newItems.push(selectAll);

    this.setState(
      {
        items: newItems,
        selectedItems: newSelectedItems,
      },
      () => {
        const pass = newSelectedItems;
        this.props.onChangeCallBack(pass);
      }
    );
  }

  //Handles the change event of the filter text
  private _onFilterChanged = (_: any, text: string): void => {
    if (this.props.onSearchChange) {
      this.props.onSearchChange(text);
    } else {
      this.loadData(text);
    }
  };

  //handles the loading of the data (initial and on change events) and populates the data accordingly.
  private loadData = (filterText = '') => {
    let { items } = this.state;
    let dropDownValues: IPickerListOption[] = [];
    let BlockerColumns = this.props.dropdownOptions;
    if (BlockerColumns && BlockerColumns.length > 0) {
      BlockerColumns.forEach((item: any) => {
        // Handle string values, objects with key/text, or objects with undefined key/text
        let key: string;
        let text: string;
        let title: string;
        if (typeof item === 'string') {
          // Direct string value
          key = item;
          text = item;
          title = item;
        } else if (item && typeof item === 'object') {
          // Object - check if key/text are defined, if not, might be accessing wrong property
          if (item.key !== undefined && item.text !== undefined) {
            key = item.key as string;
            text = item.text as string;
            title = item.title ? item.title as string : text;

          } else {
            // Object with undefined key/text - skip this item or check for other properties
            return; // Skip this item
          }
        } else {
          return; // Skip invalid items
        }
        if (key && text) {
          dropDownValues.push({
            key: key,
            text: text,
            title: title,
            isChecked: this.state.selectedItems.includes(text),
            disabled: typeof item === 'object' ? item.disabled : false,
          });
        }
      });
    }

    dropDownValues = uniqBy(dropDownValues, (e) => e.key);
    if (filterText !== '') {
      if (this.props.preSearch) {
        dropDownValues = dropDownValues.filter(
          (x) => x.text.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) === 0
        );
      } else {
        dropDownValues = dropDownValues.filter(
          (x) => x.text.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) !== -1
        );
      }
    }
    if (!this.props.disableSort) {
      dropDownValues = dropDownValues?.sort((a, b) => a.text.localeCompare(b.text));
    }

    var selectAllIndex = dropDownValues.findIndex((x) => x.key === SelectAllKey);
    if (filterText === '' && this.props.canSelectAll && this.props.dropdownOptions?.length > 0) {
      if (selectAllIndex === -1) {
        dropDownValues.unshift({
          key: SelectAllKey,
          text: SelectAllText,
          isChecked:
            this.props.selectedItems.length + items.filter((x) => x.disabled).length ===
            this.props.dropdownOptions.length && this.props.dropdownOptions.length > 0,
          disabled: false,
        });
      } else {
        dropDownValues.splice(selectAllIndex, 1);
        dropDownValues.unshift({
          key: SelectAllKey,
          text: SelectAllText,
          disabled: false,
          isChecked:
            this.props.selectedItems.length + items.filter((x) => x.disabled).length ===
            this.props.dropdownOptions.length && this.props.dropdownOptions.length > 0,
        });
      }
    }
    this.setState({ items: dropDownValues, filterText: filterText });
  };
}
// Generated by GitHub Copilot | Updated on: 2026-05-25 | 37 lines modified | US 123335: Cohort exclusivity - disabled Checkbox prop, disabled/title flag sync in componentDidUpdate, bootstrap items on first options load
